module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/cap-3-73c4ccbf332b533e6c1d9d351fa0cedd.svg";